import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class BeniDataApiResponseSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    meta: { embedded: 'always' },
    day: { embedded: 'always' },
    week: { embedded: 'always' },
    segment: { embedded: 'always' },
    los: { embedded: 'always' },
    channel: { embedded: 'always' },
  };
}
